"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var core_1 = require("@material-ui/core");
var icons_1 = require("@material-ui/icons");
var web3_js_1 = require("@solana/web3.js");
var react_1 = require("react");
var Token_1 = require("../context/Token");
var TokenList_1 = require("../context/TokenList");
var Swap_1 = require("./Swap");
var useStyles = (0, core_1.makeStyles)(function (theme) { return ({
    dialogContent: {
        padding: 0,
    },
    textField: {
        marginBottom: "8px",
    },
    tab: {
        minWidth: "80px",
    },
    tabSelected: {
        color: theme.palette.primary.contrastText,
        fontWeight: 700,
        backgroundColor: theme.palette.primary.main,
        borderRadius: "10px",
    },
    tabIndicator: {
        opacity: 0,
    },
    chip: {
        gap: theme.spacing(1),
    },
    selectTokenTitle: {
        paddingBottom: theme.spacing(2),
    },
    tokenSelector: {
        paddingTop: theme.spacing(1),
        paddingLeft: theme.spacing(0.5),
        display: "flex",
        width: "100%",
        cursor: "pointer",
    },
    closeIcon: {
        backgroundColor: theme.palette.text.secondary,
        color: theme.palette.getContrastText(theme.palette.text.secondary),
        fontSize: theme.spacing(1.5),
        borderRadius: "50%",
        padding: theme.spacing(0.3),
    },
    badge: {},
}); });
var Transition = (0, react_1.forwardRef)(function Transition(props, ref) {
    return (0, jsx_runtime_1.jsx)(core_1.Grow, __assign({ ref: ref }, props), void 0);
});
function TokenDialog(_a) {
    var open = _a.open, onClose = _a.onClose, setMint = _a.setMint;
    var _b = (0, react_1.useState)(0), tabSelection = _b[0], setTabSelection = _b[1];
    var _c = (0, react_1.useState)(""), tokenFilter = _c[0], setTokenFilter = _c[1];
    var filter = tokenFilter.toLowerCase();
    var styles = useStyles();
    var _d = (0, TokenList_1.useSwappableTokens)(), swappableTokens = _d.swappableTokens, swappableTokensSollet = _d.swappableTokensSollet, swappableTokensWormhole = _d.swappableTokensWormhole;
    var _e = (0, TokenList_1.useTokenBase)(), tokenBase = _e.tokenBase, addNewBase = _e.addNewBase, tokenBaseMap = _e.tokenBaseMap, removeBase = _e.removeBase;
    var selectedTokens = tabSelection === 0
        ? swappableTokens
        : tabSelection === 1
            ? swappableTokensWormhole
            : swappableTokensSollet;
    var tokens = tokenFilter === ""
        ? selectedTokens
        : selectedTokens.filter(function (t) {
            return t.symbol.toLowerCase().startsWith(filter) ||
                t.name.toLowerCase().startsWith(filter) ||
                t.address.toLowerCase().startsWith(filter);
        });
    return ((0, jsx_runtime_1.jsxs)(core_1.Dialog, __assign({ open: open, onClose: onClose, scroll: "paper", TransitionComponent: Transition, fullWidth: true, PaperProps: {
            style: {
                borderRadius: "10px",
                maxWidth: "420px",
                maxHeight: "clamp(100px, 80vh, 1000px)",
            },
        } }, { children: [(0, jsx_runtime_1.jsxs)(core_1.DialogTitle, __assign({ style: { fontWeight: "bold" } }, { children: [(0, jsx_runtime_1.jsxs)(core_1.Box, __assign({ display: "flex", justifyContent: "space-between", alignItems: "center", className: styles.selectTokenTitle }, { children: [(0, jsx_runtime_1.jsx)(core_1.Typography, __assign({ variant: "h6" }, { children: "Select a token" }), void 0), (0, jsx_runtime_1.jsx)(core_1.IconButton, __assign({ size: "small", onClick: onClose }, { children: (0, jsx_runtime_1.jsx)(icons_1.CloseRounded, {}, void 0) }), void 0)] }), void 0), (0, jsx_runtime_1.jsx)(core_1.TextField, { className: styles.textField, autoFocus: !/Android|webOS|iPhone|iPad/i.test(navigator.userAgent), placeholder: "Search name", value: tokenFilter, size: "small", fullWidth: true, variant: "outlined", onChange: function (e) { return setTokenFilter(e.target.value); } }, void 0), (0, jsx_runtime_1.jsx)(core_1.Typography, __assign({ variant: "caption" }, { children: "Common bases" }), void 0), (tokenBase === null || tokenBase === void 0 ? void 0 : tokenBase.length) != 0 && ((0, jsx_runtime_1.jsx)(CommonBases, { commonTokenBases: tokenBase, removeBase: removeBase, onClick: function (mint) {
                            setMint(mint);
                            onClose();
                        } }, void 0))] }), void 0), (0, jsx_runtime_1.jsx)(core_1.DialogContent, __assign({ className: styles.dialogContent, dividers: true }, { children: (0, jsx_runtime_1.jsx)(core_1.List, __assign({ disablePadding: true }, { children: tokens.map(function (tokenInfo) { return ((0, jsx_runtime_1.jsx)(TokenListItem, { tokenInfo: tokenInfo, onClick: function (mint) {
                            setMint(mint);
                            onClose();
                        }, addNewBase: function (token) {
                            addNewBase(token);
                        }, isCommonBase: tokenBaseMap.get(tokenInfo.address.toString()) ? true : false, removeBase: function (token) {
                            removeBase(token);
                        } }, tokenInfo.address)); }) }), void 0) }), void 0), (0, jsx_runtime_1.jsx)(core_1.DialogActions, __assign({ style: { justifyContent: "center" } }, { children: (0, jsx_runtime_1.jsxs)(core_1.Box, __assign({ width: "100%", display: "flex", justifyContent: "space-around" }, { children: [(0, jsx_runtime_1.jsx)(core_1.Button, __assign({ fullWidth: true, disableRipple: true, variant: tabSelection === 0 ? "contained" : "text", color: "primary", onClick: function () { return setTabSelection(0); } }, { children: "Main" }), void 0), (0, jsx_runtime_1.jsx)(core_1.Button, __assign({ fullWidth: true, disableRipple: true, variant: tabSelection === 1 ? "contained" : "text", color: "primary", onClick: function () { return setTabSelection(1); } }, { children: "Wormhole" }), void 0), (0, jsx_runtime_1.jsx)(core_1.Button, __assign({ fullWidth: true, disableRipple: true, variant: tabSelection === 2 ? "contained" : "text", color: "primary", onClick: function () { return setTabSelection(2); } }, { children: "Sollet" }), void 0)] }), void 0) }), void 0)] }), void 0));
}
exports.default = TokenDialog;
function TokenListItem(_a) {
    var _b, _c;
    var tokenInfo = _a.tokenInfo, onClick = _a.onClick, addNewBase = _a.addNewBase, removeBase = _a.removeBase, isCommonBase = _a.isCommonBase;
    var styles = useStyles();
    var theme = (0, core_1.useTheme)();
    var userTokens = (0, Token_1.useTokenContext)().userTokens;
    var mint = new web3_js_1.PublicKey(tokenInfo.address);
    // const { ownedTokensDetailed } = useTokenListContext();
    // const details = ownedTokensDetailed.filter(
    //   (t) => t.address === tokenInfo.address
    // )?.[0];
    // const details = userTokens?.[tokenInfo.address]
    var details = (0, Token_1.useOwnedTokenAccount)(mint);
    return ((0, jsx_runtime_1.jsxs)(core_1.ListItem, __assign({ button: true }, { children: [(0, jsx_runtime_1.jsxs)("div", __assign({ onClick: function () { return onClick(mint); }, className: styles.tokenSelector }, { children: [(0, jsx_runtime_1.jsx)(Swap_1.TokenIcon, { mint: mint, style: { width: theme.spacing(4), height: theme.spacing(4) } }, void 0), (0, jsx_runtime_1.jsx)(TokenName, { tokenInfo: tokenInfo }, void 0)] }), void 0), (details === null || details === void 0 ? void 0 : details.tokenAmount) && details.tokenAmount > 0 && ((0, jsx_runtime_1.jsx)(core_1.Box, __assign({ mr: 1, textAlign: "end" }, { children: (0, jsx_runtime_1.jsx)(core_1.ListItemText, { primary: details === null || details === void 0 ? void 0 : details.tokenAmount, secondary: "$".concat((_c = ((details === null || details === void 0 ? void 0 : details.tokenAmount) * ((_b = details === null || details === void 0 ? void 0 : details.priceUsdt) !== null && _b !== void 0 ? _b : 0))) === null || _c === void 0 ? void 0 : _c.toFixed(3)) }, void 0) }), void 0)), (0, jsx_runtime_1.jsx)(core_1.IconButton, __assign({ size: "small", onClick: function () {
                    return isCommonBase ? removeBase(tokenInfo) : addNewBase(tokenInfo);
                } }, { children: isCommonBase ? ((0, jsx_runtime_1.jsx)(icons_1.Star, { fontSize: "small" }, void 0)) : ((0, jsx_runtime_1.jsx)(icons_1.StarOutline, { fontSize: "small" }, void 0)) }), void 0)] }), void 0));
}
function TokenName(_a) {
    var tokenInfo = _a.tokenInfo;
    return ((0, jsx_runtime_1.jsxs)("div", __assign({ style: { marginLeft: "16px" } }, { children: [(0, jsx_runtime_1.jsx)(core_1.Typography, __assign({ style: { fontWeight: "bold" } }, { children: tokenInfo === null || tokenInfo === void 0 ? void 0 : tokenInfo.symbol }), void 0), (0, jsx_runtime_1.jsx)(core_1.Typography, __assign({ color: "textSecondary", style: { fontSize: "14px" } }, { children: tokenInfo === null || tokenInfo === void 0 ? void 0 : tokenInfo.name }), void 0)] }), void 0));
}
function CommonBases(_a) {
    var commonTokenBases = _a.commonTokenBases, onClick = _a.onClick, removeBase = _a.removeBase;
    var styles = useStyles();
    var _b = (0, react_1.useState)(""), hovered = _b[0], setHovered = _b[1];
    return ((0, jsx_runtime_1.jsx)(core_1.Box, __assign({ display: "flex", flexWrap: "wrap", className: styles.chip }, { children: commonTokenBases === null || commonTokenBases === void 0 ? void 0 : commonTokenBases.map(function (tokenInfo) {
            var mint = new web3_js_1.PublicKey(tokenInfo.address);
            return ((0, jsx_runtime_1.jsx)(core_1.Box, __assign({ onMouseEnter: function () {
                    setHovered(tokenInfo === null || tokenInfo === void 0 ? void 0 : tokenInfo.symbol);
                }, onMouseLeave: function () {
                    setHovered("");
                } }, { children: (0, jsx_runtime_1.jsx)(core_1.Badge, __assign({ badgeContent: (0, jsx_runtime_1.jsx)(icons_1.CloseRounded, { className: styles.closeIcon, onClick: function () { return removeBase(tokenInfo); } }, void 0), className: styles.badge, invisible: hovered !== (tokenInfo === null || tokenInfo === void 0 ? void 0 : tokenInfo.symbol) }, { children: (0, jsx_runtime_1.jsx)(core_1.Chip, { avatar: (0, jsx_runtime_1.jsx)(core_1.Avatar, { alt: tokenInfo === null || tokenInfo === void 0 ? void 0 : tokenInfo.name, src: tokenInfo === null || tokenInfo === void 0 ? void 0 : tokenInfo.logoURI }, void 0), variant: "outlined", label: tokenInfo === null || tokenInfo === void 0 ? void 0 : tokenInfo.symbol, onClick: function () { return onClick(mint); }, style: { borderRadius: 4 } }, tokenInfo.address) }), void 0) }), tokenInfo.address));
        }) }), void 0));
}
